import { useEffect, useState } from "react";

const upArrow = <svg xmlns="http://www.w3.org/2000/svg" className="md:h-14 md:w-14 h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" /></svg>;

export default function BackToTopButton() {
  
  const [showThis, setShow] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 400) {
        setShow(true);
      } else {
        setShow(false);
      }
    });
  }, []);

  function toTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  return (
    <>
      {showThis &&
        <button
          className="fixed lg:bottom-16 lg:right-16 md:bottom-14 bottom-6 right-6 
          md:h-14 md:w-14 h-12 w-12 rounded-full
          bg-blue-400 dark:bg-blue-600 border-orange-500 opacity-90"
          aria-label="Scroll to top of page"
          onClick={toTop}>
          {upArrow}
        </button>
      }
    </>
  );
}
